/**
 * Évite la duplication JSON-LD client lorsque le HTML Tier-1 prerender est déjà présent.
 */

export const TIER1_PRERENDER_SELECTOR = '[data-rakb-prerender]';

export const getSchemaPrimaryType = (schema: object): string | undefined => {
  const t = (schema as { '@type'?: string | string[] })['@type'];
  if (typeof t === 'string') {
    return t;
  }
  if (Array.isArray(t) && typeof t[0] === 'string') {
    return t[0];
  }
  return undefined;
};

const PRERENDER_DEDUP_TYPES = new Set([
  'Product',
  'BreadcrumbList',
  'Organization',
  'WebSite',
  'Service',
  'WebPage',
  'FAQPage',
  'ItemList',
]);

export const isProductOrBreadcrumbListSchema = (schema: object): boolean => {
  const primary = getSchemaPrimaryType(schema);
  return primary === 'Product' || primary === 'BreadcrumbList';
};

export const isPrerenderDedupSchemaType = (schema: object): boolean => {
  const primary = getSchemaPrimaryType(schema);
  return primary != null && PRERENDER_DEDUP_TYPES.has(primary);
};

export const hasTier1PrerenderInDocument = (doc: Document = document): boolean =>
  !!doc.querySelector(TIER1_PRERENDER_SELECTOR);

/** true → ne pas injecter ce schema côté client (déjà dans le @graph prerender). */
export const shouldSkipClientStructuredDataSchema = (
  schema: object,
  hasPrerender = hasTier1PrerenderInDocument()
): boolean => hasPrerender && isPrerenderDedupSchemaType(schema);

export const isProgrammaticSeoPathname = (pathname: string): boolean =>
  pathname.startsWith('/fr/location-voiture') ||
  pathname.startsWith('/en/car-rental') ||
  pathname.startsWith('/ar/location-voiture') ||
  /^\/location-voiture\/[^/]+$/.test(pathname);
